import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6064a65e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input-container" }
const _hoisted_2 = { class: "dx-field-item-label" }

import { ref, watch } from "vue";
import DxTextBox from "devextreme-vue/text-box";


export default /*#__PURE__*/_defineComponent({
  __name: 'find-input',
  props: {
  /**
   * The label displayed for the find input control.
   * @type {String}
   * @default 'Text To Find'
   */
  label: {
    type: String,
    default: "Text To Find",
  },
  /**
   * Determines if the control should be in read-only mode.
   * @type {boolean}
   * @default false
   */
  readOnly: {
    type: Boolean,
    default: false,
  },
  /**
   * Used to reset find value using the parent resetString variable.
   * @type {string}
   * @default ''
   */
  resetString: {
    type: String,
    default: "",
  },
},
  emits: [
  /**
   * Triggered when the input value changes.
   * Emits the updated value after the user stops typing for a short delay.
   */
  "changed",

  /**
   * Triggered when the input field is cleared.
   * Emits the cleared value (usually an empty string or null).
   */
  "clearedInput",
],
  setup(__props, { expose: __expose, emit }) {

const props = __props;



const findValue = ref("");
const valueChangedTimer = ref(0);

// Used to focus the find-input field from another component
const searchInputRef = ref<InstanceType<typeof DxTextBox | null>>(null);
const focus = () => {
  searchInputRef.value.instance?.focus();
};

__expose({ focus });



watch(
  () => props.resetString,
  () => {
    findValue.value = props.resetString;
  },
  { deep: true },
);

/** Handles the Value Changed event from the DxTextbox component */
const onValueChanged = (e: any) => {
  if (!e.value) {
    emit("clearedInput", e.value);
  }

  // To prevent searching whilst user is typing, reset the timer each time the input text is changed
  clearTimeout(valueChangedTimer.value);

  // To improve performance, only emit changed value when user stops typing
  valueChangedTimer.value = window.setTimeout(
    () => emit("changed", e.value),
    800,
  );
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(props.label), 1),
    _createVNode(_unref(DxTextBox), {
      ref_key: "searchInputRef",
      ref: searchInputRef,
      value: findValue.value,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((findValue).value = $event)),
      "value-change-event": "keyup",
      onValueChanged: onValueChanged,
      "max-length": 200,
      "show-clear-button": true,
      readOnly: props.readOnly
    }, null, 8, ["value", "readOnly"])
  ]))
}
}

})